import { reject } from "core-js/fn/promise";

// FIREBASE
const firebase = require("firebase");
require("firebase/firestore");
var db = firebase.firestore();

function setData(table, data, lastData = null, id = null, customer = null) {
  if (id == null) {
    db.collection(table)
      .add(data)
      .then(function(docRef) {
        id = docRef.id;
        data.id = id;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        if (table == "customers") {
          db.collection(table)
            .doc(data.id)
            .update(data)
            .then((result) => generateNavMenuItems(table, data, customer, true))
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });
        } else {
          db.collection(table)
            .doc(data.id)
            .update(data)
            .then(function(result) {
              return true;
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
            });
        }
      });
  } else {
    if (table == "customers") {
      db.collection(table)
        .doc(id)
        .update(data)
        .then((result) => generateNavMenuItems(table, data, customer))
        .catch(function(error) {
          console.error(error);
        });
    } else {
      db.collection(table)
        .doc(id)
        .update(data)
        .then(function(result) {
          return true;
        })
        .catch(function(error) {
          console.error(error);
        });
    }

    db.collection(table)
      .doc(id)
      .collection("former")
      .doc()
      .set(lastData)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
  }
}

function createNewCustomerBySupport(table, data, customer) {
  let id = null;
  let promise;
  return (promise = new Promise((resolve, reject) => {
    db.collection(table)
      .add(data)
      .then(function(docRef) {
        id = docRef.id;
        data.id = id;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        if (table == "customers") {
          db.collection(table)
            .doc(data.id)
            .update(data)
            .then(() => {
              generateNavMenuItems(table, data, customer, true);
              resolve(data);
            })
            .catch(function(error) {
              console.error("Error writing document: ", error);
              return error;
            });
        }
      });
  }));
}

function generateNavMenuItems(table, data, customer = null, saveLog = false) {
  if (table == "customers") {
    let navMenuItems = [
      {
        i18n: null,
        icon: "HomeIcon",
        name: "Tableau de bord",
        slug: "dashboard",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/dashboard",
      },
      {
        i18n: null,
        icon: "GlobeIcon",
        name: "Sites",
        slug: "sites",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites",
      },
      {
        i18n: null,
        icon: "BookOpenIcon",
        name: "Contacts",
        slug: "contacts",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/contacts",
      },
      {
        i18n: null,
        icon: "CheckSquareIcon",
        name: "Faire",
        slug: "todo",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/todo",
      },
      {
        i18n: null,
        icon: "FolderIcon",
        name: "Gestion documentaire",
        slug: "document-management",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/document-management",
      },
      {
        i18n: null,
        icon: "UsersIcon",
        name: "Utilisateurs",
        slug: "users",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/users",
      },
      {
        i18n: null,
        icon: "PenToolIcon",
        name: "Newsletter",
        slug: "newsletter",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/newsletter",
      },
      {
        i18n: null,
        icon: "HelpCircleIcon",
        name: "Support",
        slug: "support",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/support",
      },
      {
        i18n: null,
        icon: "SettingsIcon",
        name: "Paramètres",
        slug: "settings",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/settings",
      },
    ];
    let subNavMenuItems = [
      {
        i18n: null,
        icon: "HomeIcon",
        name: "Tableau de bord",
        slug: "dashboard",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/dashboard",
      },
      {
        i18n: null,
        icon: "MailIcon",
        name: "Leads",
        slug: "leads",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/leads",
      },
      {
        i18n: null,
        icon: "MenuIcon",
        name: "Menu",
        slug: "menu",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/menu",
      },
      {
        i18n: null,
        icon: "FileIcon",
        name: "Pages",
        slug: "pages",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/pages",
      },
      {
        i18n: null,
        icon: "FeatherIcon",
        name: "Blog",
        slug: "blog",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/blog",
      },
      {
        i18n: null,
        icon: "MessageSquareIcon",
        name: "Chat",
        slug: "chat",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/chat",
      },
      {
        i18n: null,
        icon: "SettingsIcon",
        name: "Paramètres du site",
        slug: "settings",
        submenu: null,
        tag: null,
        tagColor: null,
        url: "/back/sites/settings",
      },
    ];
    for (let i = 0; i < navMenuItems.length; i++) {
      const elementNavMenu = navMenuItems[i];
      for (let j = 0; j < data.navMenuPermissions.length; j++) {
        const elementPerm = data.navMenuPermissions[j];
        if (elementPerm.label == elementNavMenu.name) {
          if (elementPerm.actif == false) {
            navMenuItems.splice(i, 1);
            i--;
            break;
          }
        }
      }
    }
    for (let i = 0; i < subNavMenuItems.length; i++) {
      const elementSubNavMenu = subNavMenuItems[i];
      for (let j = 0; j < data.navMenuPermissions.length; j++) {
        const elementPerm = data.navMenuPermissions[j];
        if (elementPerm.label == elementSubNavMenu.name) {
          if (elementPerm.actif == false) {
            subNavMenuItems.splice(i, 1);
            i--;
            break;
          }
        }
      }
    }

    data.navMenuItems = navMenuItems;
    data.subNavMenuItems = subNavMenuItems;

    db.collection(table)
      .doc(data.id)
      .update(data)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
    if (saveLog == true) {
      let dataLog = {
        addDate: new Date(),
        icon: "icon-home",
        title: "Bienvenue",
        subtitle:
          "Le client " +
          data.socialReason +
          " a été créé par " +
          customer.firstname +
          " " +
          customer.lastname,
        originator: customer,
        concerned: "all",
      };
      setSubCollection("customers", "log", dataLog, data.id);
    }
  }
}

function setSubCollection(
  table,
  subTable,
  data,
  id,
  lastData = null,
  idSubCollection = null,
  thisTransfert = null
) {
  if (idSubCollection == null) {
    db.collection(table)
      .doc(id)
      .collection(subTable)
      .add(data)
      .then(function(docRef) {
        let idUpdate = docRef.id;
        data.id = idUpdate;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        db.collection(table)
          .doc(id)
          .collection(subTable)
          .doc(data.id)
          .update(data);
        if (
          table == "customers" &&
          subTable == "storage" &&
          data.type == "folder"
        ) {
          thisTransfert.$router.push({
            path: "/back/document-management/",
            params: {
              idFolder: data.id,
            },
          });
        }
      });
  } else {
    db.collection(table)
      .doc(id)
      .collection(subTable)
      .doc(idSubCollection)
      .update(data)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
    if (lastData != null) {
      db.collection(table)
        .doc(id)
        .collection(subTable)
        .doc(idSubCollection)
        .collection("former")
        .doc()
        .set(lastData)
        .then(function(result) {
          return true;
        })
        .catch(function(error) {
          console.error(error);
        });
    }
  }
}

function setSub2Collection(
  collection,
  idCollection,
  subCollection,
  idSubCollection,
  sub2Collection,
  data,
  idSub2Collection = null,
  lastData = null,
  thisTransfert = null
) {
  if (idSub2Collection == null) {
    db.collection(collection)
      .doc(idCollection)
      .collection(subCollection)
      .doc(idSubCollection)
      .collection(sub2Collection)
      .add(data)
      .then(function(docRef) {
        let idUpdate = docRef.id;
        data.id = idUpdate;
      })
      .catch(function(error) {
        console.error("Error writing document: ", error);
      })
      .finally(() => {
        db.collection(collection)
          .doc(idCollection)
          .collection(subCollection)
          .doc(idSubCollection)
          .collection(sub2Collection)
          .doc(data.id)
          .update(data);
        if (
          collection == "customers" &&
          subCollection == "sites" &&
          (sub2Collection == "pages" || sub2Collection == "articles")
        ) {
          localStorage.setItem("idPage", data.id);
          thisTransfert.$router.push({
            path: "/back/" + sub2Collection + "/editor",
          });
        }
      });
  } else {
    db.collection(collection)
      .doc(idCollection)
      .collection(subCollection)
      .doc(idSubCollection)
      .collection(sub2Collection)
      .doc(idSub2Collection)
      .update(data)
      .then(function(result) {
        return true;
      })
      .catch(function(error) {
        console.error(error);
      });
    if (lastData != null) {
      db.collection(collection)
        .doc(idCollection)
        .collection(subCollection)
        .doc(idSubCollection)
        .collection(sub2Collection)
        .doc(idSub2Collection)
        .collection("former")
        .doc()
        .set(lastData)
        .then(function(result) {
          return true;
        })
        .catch(function(error) {
          console.error(error);
        });
    }
  }
}

export {
  setData,
  setSubCollection,
  setSub2Collection,
  createNewCustomerBySupport,
};
